import { ReactComponent as DeleteIconDark } from 'core/assets/images/icones/supprimerIconedark.svg'
import { ReactComponent as DeleteIcon } from 'core/assets/images/icones/supprimerIcon.svg'
import { DarkThemeContext } from 'core/contexts/DarkThemeContext'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

type ExternalMcpCardProps = {
  url: string
  onEdit: () => void
  onDelete: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const ExternalMcpCard: React.FC<ExternalMcpCardProps> = ({
  url,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation()
  const { isDarkTheme } = useContext(DarkThemeContext)

  return (
    <div className="external-mcp-row">
      <button type="button" className="external-mcp-card" onClick={onEdit}>
        <span className="external-mcp-card-url">{url}</span>
      </button>
      <button
        type="button"
        className="external-mcp-card-delete"
        onClick={(event) => onDelete(event)}
        aria-label={t('prompts.form.advanced.mcp.deleteAriaLabel')}
      >
        {isDarkTheme ? (
          <DeleteIconDark className="h-[45px] w-[45px]" />
        ) : (
          <DeleteIcon className="h-[45px] w-[45px]" />
        )}
      </button>
    </div>
  )
}
